export enum ChoferIdioma {
  INGLES = 'Ingles',
  PORTUGUES = 'Portugues',
  ITALIANO = 'Italiano',
  ALEMAN = 'Aleman',
  OTROS = 'Otros'
}

export const IDIOMAS = Object.values(ChoferIdioma).sort();
